var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"cz2__copyright"},[_vm._v(" ©2026 Pokémon / Nintendo / Creatures / GAME FREAK ")])
}
var staticRenderFns = []

export { render, staticRenderFns }